import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import './styles/ejot.tokens.css';
import './styles/base.css';
import './styles/shell.css';
import './styles/workspace.css';
import './styles/info-controls.css';
import './styles/phase28-workflow.css';
import './styles/topological-zone-ui.css';
import './styles/mobile-navigation-v2.css';
import './styles/output-defaults-ux.css';
import './styles/product-catalogue.css';
import './styles/ui-ux-master.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('root element not found');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
